import React from 'react';

const S = ({ w = 18, h = 18, children, ...props }) => (
  <svg width={w} height={h} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false" {...props}>{children}</svg>
);

export const GlobeIcon = () => (
  <S><circle cx="12" cy="12" r="10"/><path d="M2 12h20"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></S>
);

export const BookIcon = () => (
  <S><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/></S>
);

export const ContrastIcon = () => (
  <S><circle cx="12" cy="12" r="10"/><path d="M12 2v20"/></S>
);

export const InvertIcon = () => (
  <S><circle cx="12" cy="12" r="10"/><path d="M12 2a10 10 0 0 0 0 20z"/></S>
);

export const MoonIcon = () => (
  <S><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/></S>
);

export const SunIcon = () => (
  <S><circle cx="12" cy="12" r="5"/><path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"/></S>
);

export const DropletIcon = () => (
  <S><path d="M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z"/></S>
);

export const PointerIcon = () => (
  <S><path d="M5 3l14 9-7 2-3 7z"/></S>
);

export const MinusIcon = () => (
  <S><path d="M5 12h14"/></S>
);

export const MaskIcon = () => (
  <S><rect x="2" y="7" width="20" height="10" rx="2"/></S>
);

export const ImageIcon = () => (
  <S><rect x="3" y="3" width="18" height="18" rx="2" ry="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/></S>
);

export const LinkIcon = () => (
  <S><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/></S>
);

export const HeadingIcon = () => (
  <S><path d="M6 4v16M18 4v16M6 12h12"/></S>
);

export const UnderlineIcon = () => (
  <S><path d="M6 3v7a6 6 0 0 0 6 6 6 6 0 0 0 6-6V3"/><path d="M4 21h16"/></S>
);

export const SquareIcon = () => (
  <S><rect x="3" y="3" width="18" height="18" rx="2"/></S>
);

export const PauseIcon = () => (
  <S><rect x="6" y="4" width="4" height="16"/><rect x="14" y="4" width="4" height="16"/></S>
);

export const StopIcon = () => (
  <S><rect x="4" y="4" width="16" height="16" rx="2"/></S>
);

export const CrosshairIcon = () => (
  <S><circle cx="12" cy="12" r="10"/><path d="M22 12h-4M6 12H2M12 6V2M12 22v-4"/></S>
);

export const KeyboardIcon = () => (
  <S><rect x="2" y="4" width="20" height="16" rx="2"/><path d="M6 8h.01M10 8h.01M14 8h.01M18 8h.01M8 12h.01M12 12h.01M16 12h.01M7 16h10"/></S>
);

export const A11yIcon = () => (
  <S w={28} h={28}>
    <circle cx="12" cy="4" r="2"/>
    <path d="M12 7.5v7"/>
    <path d="M12 9.5l-4.5 2.5"/>
    <path d="M12 9.5l4.5 2.5"/>
    <path d="M12 14.5l-3.5 5"/>
    <path d="M12 14.5l3.5 5"/>
  </S>
);

export const A11yIconFilled = ({ w = 28, h = 28 }) => (
  <svg width={w} height={h} viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
    <circle cx="12" cy="4" r="2.4" fill="currentColor"/>
    <path d="M12 7.5v7" stroke="currentColor" strokeWidth="3" strokeLinecap="round"/>
    <path d="M12 9.5l-4.5 2.5" stroke="currentColor" strokeWidth="3" strokeLinecap="round"/>
    <path d="M12 9.5l4.5 2.5" stroke="currentColor" strokeWidth="3" strokeLinecap="round"/>
    <path d="M12 14.5l-3.5 5" stroke="currentColor" strokeWidth="3" strokeLinecap="round"/>
    <path d="M12 14.5l3.5 5" stroke="currentColor" strokeWidth="3" strokeLinecap="round"/>
  </svg>
);

export const CloseIcon = () => (
  <S w={18} h={18}><path d="M18 6L6 18M6 6l12 12"/></S>
);

export const BrightnessIcon = () => (
  <S><path d="M12 3a6 6 0 0 0 0 12 6 6 0 0 0 0-12z"/><path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"/></S>
);

export const TextIcon = () => (
  <S><path d="M4 7V4h16v3"/><path d="M9 20h6"/><path d="M12 4v16"/></S>
);
